<template>
  <div id="map"></div>
</template>
<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import * as olProj from 'ol/proj'
import ScaleLine from 'ol/control/ScaleLine'
import { defaults } from 'ol/interaction'
import Feature from 'ol/Feature'
import { Vector as VectorLayer } from 'ol/layer'
import { getVectorContext } from 'ol/render'
import LineString from 'ol/geom/LineString'
import * as turf from '@turf/turf'
import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from 'ol/style'
let lastTime
var geoMarker
var routeFeature
var styles
let distance = 0
var position
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      this.map = new Map({
        view: new View({
          center: [113.67939908770235, 25.53576677844281], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 14, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        target: 'map' // 地图容器id
      })
      const scaleLineControl = new ScaleLine({
        // 设置度量单位为米
        units: 'metric',
        target: 'scalebar',
        className: 'ol-scale-line'
      })
      this.map.addControl(scaleLineControl)
      const road_layer = new TileLayer({
        name: '底图',
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      this.map.addLayer(road_layer)
      this.createIcon(0)
      this.startAnimation()
    },
    moveFeature(event) {
      const speed = 100.0
      const time = event.frameState.time
      const elapsedTime = time - lastTime
      distance = (distance + (speed * elapsedTime) / 1e6) % 2
      lastTime = time

      const currentCoordinate = routeFeature.getGeometry().getCoordinateAt(distance > 1 ? 2 - distance : distance)
      var from = turf.point(currentCoordinate)
      var to = turf.point(this.data[this.data.length - 1])
      var options = { units: 'kilometers' }
      var pointDistance = turf.distance(from, to, options)
      if (pointDistance <= 0.005) {
        this.stopAnimation()
      }
      position.setCoordinates(currentCoordinate)
      const vectorContext = getVectorContext(event)
      vectorContext.setStyle(styles.geoMarker)
      vectorContext.drawGeometry(position)
      // tell OpenLayers to continue the postrender animation
      this.map.render()
    },
    startAnimation() {
      //   animating = true;
      lastTime = Date.now()
      this.vectorLayer.on('postrender', this.moveFeature)
      geoMarker.setGeometry(null)
    },
    stopAnimation() {
      //   animating = false;
      geoMarker.setGeometry(position)
      this.vectorLayer.un('postrender', this.moveFeature)
    },
    createIcon() {
      // console.log(this.data)
      routeFeature = new Feature({
        type: 'route',
        geometry: new LineString(this.data)
      })
      console.log(new LineString(this.data))
      const startMarker = new Feature({
        type: 'icon',
        geometry: new Point(this.data[0])
      })
      const endMarker = new Feature({
        type: 'endicon',
        geometry: new Point(this.data[this.data.length - 1])
      })
      position = startMarker.getGeometry().clone()
      geoMarker = new Feature({
        type: 'geoMarker',
        geometry: position
      })
      styles = {
        route: new Style({
          stroke: new Stroke({
            width: 6,
            color: [237, 212, 0, 0.8]
          })
        }),
        icon: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: require('@/assets/myImg/1/icon-water-meter.png')
          })
        }),
        endicon: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: require('@/assets/myImg/1/icon-fire-hydrant.png')
          })
        }),
        geoMarker: new Style({
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({ color: 'black' }),
            stroke: new Stroke({
              color: 'white',
              width: 2
            })
          })
        })
      }
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [routeFeature, geoMarker, startMarker, endMarker]
        }),
        style: function(feature) {
          return styles[feature.get('type')]
        }
      })
      this.map.addLayer(this.vectorLayer)
    }
  }
}
</script>

<style lang="less" scoped>
#map {
  width: 750px;
  height: 500px;
}
</style>
